import { call, put, select, takeLatest } from 'redux-saga/effects';
import discountService from '../services/discount';
import { selectConfig } from '../features/config/configSlice';
import { DISCOUNT_CODE_ERRORS } from '../constants';

export function* applyDiscount({ payload: { discountCode } }) {
  try {
    const config = yield select(selectConfig);

    const result = yield call(discountService.applyDiscount, { config, discountCode });

    yield put({ type: 'discount/discountCodeSuccess' });
    yield put({ type: 'railcards/setDiscounts', payload: result });
  } catch (_e) {
    const errorMessage =
      _e?.message === DISCOUNT_CODE_ERRORS.INVALID
        ? 'No discount found or it has expired.'
        : 'An error occurred while applying the discount code. Please try again.';
    yield put({ type: 'discount/discountCodeFailure', payload: errorMessage });
    yield put({ type: 'railcards/setDiscounts', payload: { discounts: null } });
  }
}

function* discountSaga() {
  yield takeLatest('discount/applyDiscount', applyDiscount);
}

export default discountSaga;
